import EyeDrawSection from '../EyeDrawSection';
import thumb17 from '../images/thumb_17.jpg';
import thumb18 from '../images/thumb_18.jpg';
import thumb19 from '../images/thumb_19.jpg';
import img17 from '../images/17.png';
import img18 from '../images/18.png';
import img19 from '../images/19.png';

const cards = [
    { title: 'Cataract - Cortical', thumb: thumb17, image: img17 },
    { title: 'Cataract - Cortical', thumb: thumb18, image: img18 },
    { title: 'Cataract - Posterior Capsular', thumb: thumb19, image: img19 },
];

export default function Cataract() {
    return <EyeDrawSection id="cataract" title="Cataract" icon="bi-cloud" cards={cards} />;
}
